import useGetActivitiesByKey from '../providers/ActivityKeyer/useGetActivitiesByKey';

export default useGetActivitiesByKey;
